/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReleaseNoteList,
    ReleaseNoteListFromJSON,
    ReleaseNoteListToJSON,
} from '../models';

export interface GetReleaseNoteImageGifRequest {
    releaseNoteId: number;
}

export interface GetReleaseNoteImageJpgRequest {
    releaseNoteId: number;
}

export interface GetReleaseNoteImagePngRequest {
    releaseNoteId: number;
}

/**
 * 
 */
export class ReleaseNoteApi extends runtime.BaseAPI {

    /**
     * リリースノート画像（GIF）
     */
    async getReleaseNoteImageGifRaw(requestParameters: GetReleaseNoteImageGifRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.releaseNoteId === null || requestParameters.releaseNoteId === undefined) {
            throw new runtime.RequiredError('releaseNoteId','Required parameter requestParameters.releaseNoteId was null or undefined when calling getReleaseNoteImageGif.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/release_notes/{release_note_id}/image.gif`.replace(`{${"release_note_id"}}`, encodeURIComponent(String(requestParameters.releaseNoteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * リリースノート画像（GIF）
     */
    async getReleaseNoteImageGif(requestParameters: GetReleaseNoteImageGifRequest): Promise<Blob> {
        const response = await this.getReleaseNoteImageGifRaw(requestParameters);
        return await response.value();
    }

    /**
     * リリースノート画像（JPEG）
     */
    async getReleaseNoteImageJpgRaw(requestParameters: GetReleaseNoteImageJpgRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.releaseNoteId === null || requestParameters.releaseNoteId === undefined) {
            throw new runtime.RequiredError('releaseNoteId','Required parameter requestParameters.releaseNoteId was null or undefined when calling getReleaseNoteImageJpg.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/release_notes/{release_note_id}/image.jpg`.replace(`{${"release_note_id"}}`, encodeURIComponent(String(requestParameters.releaseNoteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * リリースノート画像（JPEG）
     */
    async getReleaseNoteImageJpg(requestParameters: GetReleaseNoteImageJpgRequest): Promise<Blob> {
        const response = await this.getReleaseNoteImageJpgRaw(requestParameters);
        return await response.value();
    }

    /**
     * リリースノート画像（PNG）
     */
    async getReleaseNoteImagePngRaw(requestParameters: GetReleaseNoteImagePngRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.releaseNoteId === null || requestParameters.releaseNoteId === undefined) {
            throw new runtime.RequiredError('releaseNoteId','Required parameter requestParameters.releaseNoteId was null or undefined when calling getReleaseNoteImagePng.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/release_notes/{release_note_id}/image.png`.replace(`{${"release_note_id"}}`, encodeURIComponent(String(requestParameters.releaseNoteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * リリースノート画像（PNG）
     */
    async getReleaseNoteImagePng(requestParameters: GetReleaseNoteImagePngRequest): Promise<Blob> {
        const response = await this.getReleaseNoteImagePngRaw(requestParameters);
        return await response.value();
    }

    /**
     * リリースノートリスト
     */
    async getReleaseNotesRaw(): Promise<runtime.ApiResponse<ReleaseNoteList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/release_notes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReleaseNoteListFromJSON(jsonValue));
    }

    /**
     * リリースノートリスト
     */
    async getReleaseNotes(): Promise<ReleaseNoteList> {
        const response = await this.getReleaseNotesRaw();
        return await response.value();
    }

}
